export interface EncryptedToken {
  token: string;
}

export interface DecryptedData {
  [name: string]: string | string[];
}
